
import eventBus, { GLOBAL_EVENT_SELECTED_PLANT_TYPE_CHANGED } from '@/lib/global-event-bus';
import { plantImageUrl, PLANT_ICON_NAMES } from '@/lib/plant-images';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class LogoSelector extends Vue {
  plantImageUrl = plantImageUrl;

  /** Same order as `PLANT_ICON_NAMES` in `@/lib/plant-images`. */
  imagesNames = [...PLANT_ICON_NAMES];
  activeImageName = this.imagesNames[0];
  isExpanded = false;
  animateIn = false;
  isClosing = false;
  animateHeartbeat = false;

  mounted() {
    if (document.hidden) {
      const functionRef = () => {
        this.animateLogo();
        document.removeEventListener('visibilitychange', functionRef);
      };
      document.addEventListener('visibilitychange', functionRef);
    } else {
      this.animateLogo();
    }

    eventBus.$on(GLOBAL_EVENT_SELECTED_PLANT_TYPE_CHANGED, this.selectPlant);
  }

  beforeDestroy() {
    eventBus.$off(GLOBAL_EVENT_SELECTED_PLANT_TYPE_CHANGED, this.selectPlant);
    document.removeEventListener('mousedown', this.onDocumentClick);
    document.removeEventListener('touchstart', this.onDocumentTouch);
  }

  get isPlantSelected() {
    return this.activeImageName !== this.imagesNames[0];
  }

  private animateLogo() {
    this.onNextTickRerender(() => {
      this.animateIn = true;
      setTimeout(() => {
        this.animateIn = false;
        this.animateHeartbeat = true;
        setTimeout(() => {
          this.animateHeartbeat = false;
        }, 1050);
      }, 800);
    });
  }

  handleImageClick(imageName: string) {
    if (this.isExpanded) {
      this.selectPlant(imageName);
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isExpanded = true;
    document.addEventListener('mousedown', this.onDocumentClick);
    document.addEventListener('touchstart', this.onDocumentTouch, { passive: true });
  }

  close() {
    this.isExpanded = false;
    this.isClosing = true;
    setTimeout(() => {
      this.isClosing = false;
    }, 260);
    document.removeEventListener('mousedown', this.onDocumentClick);
    document.removeEventListener('touchstart', this.onDocumentTouch);
  }

  onDocumentClick(event: MouseEvent) {
    if (!event.composedPath().includes(this.$refs.logoSelector as HTMLElement)) {
      this.close();
    }
  }

  onDocumentTouch(event: TouchEvent) {
    if (!event.composedPath().includes(this.$refs.logoSelector as HTMLElement)) {
      this.close();
    }
  }

  selectPlant(selectedPlantTypeName: string) {
    const imageName = selectedPlantTypeName || this.imagesNames[0];
    this.activeImageName = imageName;
    this.setImageAsFavicon(imageName);
    this.$emit('plant-type-change', selectedPlantTypeName);
  }

  private setImageAsFavicon(imageName: string) {
    const link = document.querySelector("link[rel~='icon']") as HTMLAnchorElement;
    if (link) {
      link.href = plantImageUrl(imageName);
    }
  }
}
